module.exports = __webpack_public_path__ + "static/media/7-implementation.51a67af1.svg";